import { RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils/cn";

/** EmptyState's sibling for a load that failed: what happened and, usually, a retry. */
export function ErrorState({
  error,
  onRetry,
  testId,
  className,
}: {
  error: unknown;
  /** Usually React Query's `refetch`. */
  onRetry?: () => void;
  testId?: string;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      data-testid={testId}
      className={cn(
        "flex flex-col items-center gap-2 rounded-lg border border-destructive/40 px-6 py-10 text-center",
        className,
      )}
    >
      <p className="font-medium">{t("common.loadFailed")}</p>
      {error instanceof Error && (
        <p className="max-w-md text-sm text-muted-foreground">{error.message}</p>
      )}
      {onRetry && (
        <Button
          variant="outline"
          size="sm"
          className="mt-2"
          onClick={onRetry}
          data-testid={testId && `${testId}-retry`}
        >
          <RotateCcw /> {t("common.retry")}
        </Button>
      )}
    </div>
  );
}
